module.exports = __webpack_public_path__ + "assetsclientes/img/pose-m-1.dac21df9.png";